<script lang="ts" setup>
import { defineProps } from 'vue'

defineProps({
  isLoading: {
    type: Boolean,
  },
  repeat: {
    type: Number,
    default: 1,
  },
  className: {
    type: String,
    default: '',
  },
})
</script>

<template>
  <div v-for="n in repeat" :key="n" :class="['shimmer', className]"/>
</template>

<style scoped>
/* ... (keep the existing styles) ... */

.shimmer-wrapper {
  display: flex;
  flex-direction: column;
}
/* Transition styles */

.shimmer-wrapper.hidden {
  opacity: 0;
  pointer-events: none;
}
.shimmer {
  background: var(--shimmer-color);
  background-image: linear-gradient(
    to right,
    var(--shimmer-color) 0%,
    var(--shimmer-highlight) 20%,
    var(--shimmer-color) 40%,
    var(--shimmer-color) 100%
  );
  background-size: 200% 200%; /* Ensure the gradient is large enough */
  animation: shimmer 2s infinite;
  background-repeat: no-repeat;

  display: block;
  position: relative;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: linear;
}

@keyframes shimmer {
  0% {
    background-position: -468px 0;
  }
  100% {
    background-position: 468px 0;
  }
}
/* Add any additional styles for repeated elements if needed */
</style>
